/**
 * Inicializa a funcionalidade de compartilhamento (Popover e Copiar Link)
 */
export default function initShare() {
    // ==========================================
    // 1. LÓGICA DE ABRIR/FECHAR O POPOVER (CLIQUE)
    // ==========================================
    const shareContainers = document.querySelectorAll('.share-container');

    shareContainers.forEach(container => {
        // Encontra o botão azul dentro deste container específico
        const btnShare = container.querySelector('.c-galeria__compartilhar');

        if (btnShare) {
            btnShare.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation(); // Evita que o clique "vaze" para o document

                // Fecha outros popovers que possam estar abertos na página
                document.querySelectorAll('.share-container.is-active').forEach(activeContainer => {
                    if (activeContainer !== container) {
                        activeContainer.classList.remove('is-active');
                    }
                });

                // Alterna a classe (abre/fecha) do popover atual
                container.classList.toggle('is-active');
            });
        }
    });

    // UX: Fecha o popover se o usuário clicar em qualquer outro lugar da tela
    document.addEventListener('click', (e) => {
        shareContainers.forEach(container => {
            // Se o popover tá ativo e o clique foi FORA do container, ele fecha
            if (container.classList.contains('is-active') && !container.contains(e.target)) {
                container.classList.remove('is-active');
            }
        });
    });

    // ==========================================
    // 2. LÓGICA DE COPIAR O LINK
    // ==========================================
    const copyButtons = document.querySelectorAll('.popover-item[data-action="copy"]');

    if (!copyButtons.length) return;

    copyButtons.forEach(button => {
        button.addEventListener('click', async function (e) {
            e.preventDefault();
            e.stopPropagation(); // Evita que o clique de copiar feche o popover instantaneamente

            const urlToCopy = window.location.href;
            const label = this.querySelector('.label');
            const originalText = label ? label.innerText : 'Copiar link';

            try {
                await navigator.clipboard.writeText(urlToCopy);

                if (label) {
                    label.innerText = 'Copiado!';
                    this.classList.add('is-copied');

                    setTimeout(() => {
                        label.innerText = originalText;
                        this.classList.remove('is-copied');
                    }, 2000);
                }
            } catch (err) {
                console.error('Erro ao copiar link: ', err);
                alert('Não foi possível copiar o link automaticamente.');
            }
        });
    });
}